import { useEffect, useState } from "react"
import { useFirestore } from "react-redux-firebase"
// import useCustomerData from "./useCustomerData"

export default function useProfileSettings({ notify, customer, auth }) {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [updateLoading, setUpdateLoading] = useState(false)

  const firestore = useFirestore()

  useEffect(() => {
    if (customer) {
      if (customer?.name) {
        setName(customer?.name)
      }
      if (customer?.email) {
        setEmail(customer?.email)
      }
      if (customer?.phone) {
        setPhone(customer?.phone)
      }
    }
  }, [customer])

  const updateProfile = async () => {
    try {
      setUpdateLoading(true)
      const data = { email, name, phone }
      await firestore
        .collection("customers")
        .doc(auth?.uid)
        .set(data, { merge: true })
      const message = "Profile updated successfully."
      notify("success", message, "Success")
    } catch (error) {
      console.log(`error`, error)
    } finally {
      setUpdateLoading(false)
    }
  }

  return {
    name,
    setName,
    email,
    setEmail,
    phone,
    setPhone,
    updateProfile,
    updateLoading,
  }
}
